import React, { useMemo, useState } from "react";
import { Eyebrow, Title } from "../components/CommonComponents";
import MetaInfo from "../components/MetaInfo";
import Header from "../components/Header";
import Footer from "../components/Footer";

const committees = [
    {
        title: "Examination Committee",
        tag: "Academic Administration",
        responsibility: "Supports the University's examination-related academic administration and coordination responsibilities.",
        members: [
            { name: "Dr. B. P. Bhol", designation: "Member" },
            { name: "Dr. Rani Jha", designation: "Member" },
            { name: "Dr. Garima Diwan", designation: "Member" },
            { name: "Dr. N. Kumar Swamy", designation: "Member" },
            { name: "Mr. Takeshwar Kaushik", designation: "Member" },
            { name: "Mr. Govinda Sahu", designation: "Member" },
            { name: "Dr. Poonam Verma", designation: "Member" },
            { name: "Mr. Rajendra Prasad Gendre", designation: "Member" },
            { name: "Ms. Vimla Sona", designation: "Member" },
            { name: "Mr. Yugal Kishor Rajput", designation: "Member" },
            { name: "Mrs. Keshar Lata Sahu", designation: "Member" },
        ],
    },
    {
        title: "Discipline Committee",
        tag: "Campus Discipline",
        responsibility: "Supports orderly conduct, discipline and responsible behaviour within the University environment.",
        members: [
            { name: "Dr. Gokul Prasad Sahu", designation: "Member" },
            { name: "Mr. Sidharth Mishra", designation: "Member" },
            { name: "Mr. Sanjiv Jangde", designation: "Member" },
            { name: "Mr. Hemant Pandey", designation: "Member" },
            { name: "Ms. Lukeshwari Verma", designation: "Member" },
            { name: "Ms. Lalita Sahu", designation: "Member" },
        ],
    },
    {
        title: "Training, Placement and Entrepreneurship Committee",
        tag: "Career Development",
        responsibility: "Supports training, placement preparation, employability development and entrepreneurship-oriented activities.",
        members: [
            { name: "Dr. Rani Jha", designation: "Member" },
            { name: "Dr. Poonam Verma", designation: "Member" },
            { name: "Dr. Garima Diwan", designation: "Member" },
            { name: "Mr. Khemanshu Kumar Sahu", designation: "Member" },
        ],
    },
    {
        title: "Hostel Committee",
        tag: "Residential Life",
        responsibility: "Supports the administration, coordination and welfare of students within University hostel facilities.",
        members: [
            { name: "Mr. Arjun Singh", designation: "Member" },
            { name: "Mr. Gaurav Kumar", designation: "Member" },
            { name: "Dr. Poonam Verma", designation: "Member" },
            { name: "Dr. Ram Krishna Deshmukh", designation: "Member" },
        ],
    },
    {
        title: "Health and Hygiene Committee",
        tag: "Health & Wellbeing",
        responsibility: "Supports health, hygiene and wellbeing-related awareness and practices across the University community.",
        members: [
            { name: "Dr. Garima Diwan", designation: "Member" },
            { name: "Mr. Yugal Kishor Rajput", designation: "Member" },
            { name: "Mr. Rajendra Kumar Sahu", designation: "Member" },
            { name: "Mr. Ashwanee Kumar Sahu", designation: "Member" },
            { name: "Ms. Lukeshwari Verma", designation: "Member" },
        ],
    },
    {
        title: "NCC & NSS Committees",
        tag: "Community Engagement",
        responsibility: "Supports student participation in NCC and NSS activities, civic engagement and community-oriented initiatives.",
        members: [
            { name: "Dr. Gokul Prasad Sahu", designation: "Member" },
            { name: "Dr. Preetam Sahu", designation: "Member" },
            { name: "Mr. Pukhraj Yadav", designation: "Member" },
            { name: "Ms. Vimla Sona", designation: "Member" },
            { name: "Mr. Ashwani Kumar Sahu", designation: "Member" },
        ],
    },
    {
        title: "Anti Ragging Committee",
        tag: "Student Safety",
        responsibility: "Supports the University's anti-ragging framework, preventive measures and student safety responsibilities.",
        members: [
            { name: "Prof. (Dr) Anand Mahalwar", designation: "Chairman" },
            { name: "Dr. B. P. Bhol", designation: "Registrar" },
            { name: "Dr. Sandeep Kumar", designation: "DSW, Member" },
            { name: "Dr. N. Kumar Swamy", designation: "ARC, Member" },
            { name: "Mr. Rajendra Prasad Gendre", designation: "ARC, Member" },
            { name: "Ms. Poonam Rajput", designation: "ARC, Member" },
            { name: "Mr. Ramkrishna Deshmukh", designation: "Hostel Warden (Boys)" },
            { name: "Smt. Kesharlata Sahu", designation: "Hostel Warden (Girls)" },
            { name: "TI, Chhura", designation: "Member representative of Police Admin" },
            { name: "Mr. Yashwant Yadaw (Media)", designation: "Member Local Media" },
            { name: "Mr. Sheetal Dhruw (NGO)", designation: "Member NGO" },
            { name: "Mr. Pukhraj Yadaw", designation: "Member Non teaching" },
            { name: "Mr. Arjun Singh", designation: "Member (Administration)" },
            { name: "Mr. Purshottam", designation: "Member Parents" },
            { name: "Mr. Mahesh Kumar Sahu", designation: "Member Parents" },
            { name: "Mr. Jaykumar", designation: "Member Student – Fresher’s" },
            { name: "Monika Yadu", designation: "Member Student – Fresher’s" },
            { name: "Kishan Dewangan", designation: "Member Senior Student" },
            { name: "Harsh Yadu", designation: "Member Senior Student" },
        ],
    },
    {
        title: "ST/SC Committee",
        tag: "Equity & Inclusion",
        responsibility: "Supports institutional responsibilities relating to ST/SC student welfare, representation and inclusive participation.",
        members: [
            { name: "Dr. Anand Mahalwar, Vice-Chancellor", designation: "Chairman" },
            { name: "Dr. N. Kumar Swamy, Dean Academics", designation: "Member" },
            { name: "Dr. Sandeep Sahu, Dean of Student Affairs", designation: "Member" },
            { name: "Mr. Sanjeev Jandge, Asst. Prof.", designation: "Member" },
            { name: "Mr. Rajendra Prasad Gendre, Asst. Prof", designation: "Member" },
            { name: "Ms. Vimla Sona, Asst. Prof.", designation: "Member" },
            { name: "Mr. Mohit Ram Chelak, Asst. Prof.", designation: "Member" },
            { name: "Ms. Lukeshwari Verma, Asst. Prof.", designation: "Member" },
            { name: "Mr. Vagesh Kumbhakar, Asst. Prof.", designation: "Member" },
            { name: "Dr. Barada Prasad Bhol, Registrar", designation: "Member Secretary" },
        ],
    },
    {
        title: "Other Backward Class Committee",
        tag: "Equity & Inclusion",
        responsibility: "Supports OBC-related institutional coordination, representation and liaison responsibilities within the University.",
        members: [
            { name: "Dr. Sandeep Sahu, DSW", designation: "Convener" },
            { name: "Dr. N.K Swamy, Director IQAC", designation: "Member Secretary" },
            { name: "Dr. Preetam Sahu, Asst. Prof. Faculty of Arts & Humanities", designation: "Member" },
            { name: "Dr. Gokul Prasad Sahu, Asst. Prof. Faculty of Science", designation: "Member" },
            { name: "Dr. Garima Diwan, Associate Prof. Faculty of Arts & Humanities", designation: "Member" },
            { name: "Dr. Poonam Verma, Asst. Prof. Faculty of Science", designation: "Member" },
            { name: "Mr. Rameshwar Nishad, Asst. Prof. Faculty of Science", designation: "Liaison officer for OBC Cell (nominated by Vice Chancellor)" },
            { name: "Dr. Ram Krishna Deshmukh, Asst. Prof. Faculty of Science", designation: "Liaison officer for OBC Cell (nominated by Vice Chancellor)" },
        ],
    },
    {
        title: "Student Counselling Committee",
        tag: "Student Support",
        responsibility: "Supports counselling, student guidance and academic or personal support through representatives from different faculties and students.",
        members: [
            { name: "Dr. Barada Prasad Bhol", designation: "Registrar, ISBM University" },
            { name: "Dr. N. Kumar Swamy", designation: "Dean Academics, ISBM University" },
            { name: "Dr. Garima Diwan", designation: "Faculty of Arts & Humanities" },
            { name: "Dr. Abha Tamrakar", designation: "Faculty of Information Technology" },
            { name: "Dr. Samata Jain", designation: "Faculty of Commerce & Management" },
            { name: "Dr. Poonam Verma", designation: "Faculty of Science" },
            { name: "Ms. Vimla Sona", designation: "Faculty of Library & Information Science" },
            { name: "Mr. Yugal Kishor Rajput", designation: "Faculty of Pharmacy" },
            { name: "Mr. Rajendra Kumar Gendre", designation: "Faculty of Law" },
            { name: "Mr. Khemchand Sahu", designation: "Student Representative (BA)" },
            { name: "Mr. Chanchal", designation: "Student Representative (B.Sc)" },
            { name: "Mr. Ishwar Singh", designation: "Student Representative (M.Sc)" },
            { name: "Mr. Harsh Choudhari", designation: "Student Representative" },
        ],
    },
    {
        title: "Internal Committee",
        tag: "Institutional Coordination",
        responsibility: "Supports internal institutional coordination through faculty, non-teaching staff and student representation.",
        members: [
            { name: "Dr. N. Kumar Swamy", designation: "Principal" },
            { name: "Mr. Takeshwar Kaushik", designation: "Member of faculty" },
            { name: "Mr. Khemanshu Sahu", designation: "Member of faculty" },
            { name: "Mr. Chhannu Thakur", designation: "Non-teaching staff" },
            { name: "Mr. Raghvendra", designation: "Non-teaching staff" },
            { name: "Mr. Gautam", designation: "Students" },
            { name: "Mr. Rupendra", designation: "Students" },
            { name: "Ms. Moksha Rani Sahu", designation: "Students" },
        ],
    },
    {
        title: "Internal Complaints Committee under the Sexual Harassment of Women at Workplace (Prevention, Prohibition and Redressal) Act, 2013",
        tag: "Safety & Redressal",
        responsibility: "Supports the University's statutory mechanism for prevention, prohibition and redressal of sexual harassment complaints in accordance with the stated Act.",
        members: [
            { name: "Dr. Garima Diwan", designation: "Chairperson" },
            { name: "Mr. Rajendra Prasad Gendre", designation: "Member" },
            { name: "Mr. Ashwani Kumar Sahu", designation: "Member" },
            { name: "Mrs. Rameshwari Yadaw", designation: "Member" },
            { name: "Ms. Saniya Dhruw", designation: "Member" },
            { name: "Ms. Anju", designation: "Member" },
        ],
    },
    {
        title: "Sport Committee",
        tag: "Sports & Recreation",
        responsibility: "Supports planning, coordination and student participation in sports and recreation-related activities.",
        members: [
            { name: "Mr. Ashwani Kumar Sahu", designation: "Asst. Prof. School of Arts & Humanities" },
            { name: "Dr. Gokul Prasad", designation: "Asst. Prof. School of Science" },
            { name: "Mr. Hemant Pandey", designation: "Asst. Prof. School of Science" },
            { name: "Mr. Dusyant Yadav", designation: "Asst. Prof. School of Engineering & Technology" },
            { name: "Ms. Ranu Verma", designation: "Asst. Prof. School of Science" },
            { name: "Ms. Rekha Sahu", designation: "Asst. Prof. School of Science" },
            { name: "Mr. Chandramani Sahu", designation: "Asst. Prof. School of IT" },
            { name: "Mr. Sanjiv Jangde", designation: "Asst. Prof. School of Engineering & Technology" },
        ],
    },
    {
        title: "Cultural Committee",
        tag: "Culture & Engagement",
        responsibility: "Supports cultural programming, student participation and coordination of creative and co-curricular activities.",
        members: [
            { name: "Ms. Vimla Sona", designation: "Asst. Prof. School of Library & Information Science" },
            { name: "Mr. Preetam", designation: "Asst. Prof. School of Arts & Humanities" },
            { name: "Ms. Poonam Rajput", designation: "Asst. Prof. School of Pharmacy" },
            { name: "Mr. Pukhraj Yadav", designation: "Asst. Librarian" },
            { name: "Ms. Lalita Sahu", designation: "Asst. Prof. School of Science" },
            { name: "Mr. Rajendra Kumar Sahu", designation: "Asst. Prof. School of Pharmacy" },
            { name: "Ms. Gaytri", designation: "Student Member (M.Sc)" },
            { name: "Mr. Akash Barai", designation: "Student Member (BBA LLB)" },
            { name: "Mr. Ved Prakash", designation: "Student Member (B.Pharma)" },
        ],
    },
    {
        title: "Gender Sensitization Cell",
        tag: "Gender Sensitization",
        responsibility: "Supports awareness, sensitization and institutional responsibility relating to gender equality and respectful campus culture.",
        members: [
            { name: "Dr. Garima Diwan", designation: "Presiding Officer" },
            { name: "Ms. Khusboo Rajpoot", designation: "Member" },
            { name: "Dr. Poonam Verma", designation: "Member" },
            { name: "Ms. Rekha Sahu", designation: "Member" },
            { name: "Mrs. Nimmi Sahu", designation: "Member" },
            { name: "Harsh Yadu (BA)", designation: "Member" },
            { name: "Prasant Yadaw (B.Com)", designation: "Member" },
            { name: "Sohendra Sahu (B.Sc)", designation: "Member" },
        ],
    },
    {
        title: "STUDENTS' GRIEVANCE REDRESSAL COMMITTEE",
        tag: "Grievance Redressal",
        responsibility: "Supports formal student grievance redressal through designated academic, administrative and student representatives.",
        members: [
            { name: "Dr. Bhupendra Kumar", designation: "Chairperson, DSW" },
            { name: "Dr. Garima Diwan", designation: "HOD SO&AH" },
            { name: "Mr. Rajendra Kumar Gendre", designation: "Member HOD Law" },
            { name: "Dr. Poonam Verma", designation: "Member HOD SOS" },
            { name: "Ms. Vimla Sona", designation: "Member HOD SOL& I" },
            { name: "Mr. Bhagwan Singh", designation: "Student Member" },
        ],
    },
];

const responsibilityGroups = [
    {
        number: "01",
        label: "Academic Governance",
        title: "Academic & Administrative Responsibility",
        description:
            "Supporting examinations, academic administration, internal coordination and the orderly functioning of University processes.",
        background: "bg-[#F7F2E8]",
        committees: [
            "Examination Committee",
            "Discipline Committee",
            "Internal Committee",
        ],
    },
    {
        number: "02",
        label: "Student Welfare",
        title: "Safety, Wellbeing & Student Support",
        description:
            "Creating a safe, supportive and responsible environment through welfare, counselling, residential support, health and grievance mechanisms.",
        background: "bg-[#EEF4F8]",
        committees: [
            "Anti Ragging Committee",
            "Hostel Committee",
            "Health and Hygiene Committee",
            "Student Counselling Committee",
            "STUDENTS' GRIEVANCE REDRESSAL COMMITTEE",
        ],
    },
    {
        number: "03",
        label: "Inclusion & Redressal",
        title: "Inclusion, Equality & Protection",
        description:
            "Supporting representation, equal opportunity, gender sensitization and statutory complaint redressal across the University.",
        background: "bg-[#F4E8EC]",
        committees: [
            "ST/SC Committee",
            "Other Backward Class Committee",
            "Gender Sensitization Cell",
            "Internal Complaints Committee under the Sexual Harassment of Women at Workplace (Prevention, Prohibition and Redressal) Act, 2013",
        ],
    },
    {
        number: "04",
        label: "Development & Engagement",
        title: "Career, Community & Campus Engagement",
        description:
            "Supporting professional development, entrepreneurship, social participation, sport and cultural engagement beyond academics.",
        background: "bg-[#071A2F]",
        dark: true,
        committees: [
            "Training, Placement and Entrepreneurship Committee",
            "NCC & NSS Committees",
            "Sport Committee",
            "Cultural Committee",
        ],
    },
];

export default function OtherCommittees() {
    return (
        <>
            <MetaInfo param="" id="about" />

            <Header school="common" />

            <main className="overflow-hidden bg-white">

                {/* HERO */}
                <section className="relative isolate min-h-[70vh] overflow-hidden bg-[#071A2F] text-white">

                    <div className="absolute inset-0 -z-20 bg-[linear-gradient(120deg,rgba(255,255,255,0.035),transparent_38%)]" />

                    <div className="absolute -right-24 top-24 -z-10 h-[420px] w-[420px] rounded-full border border-white/[0.06]" />

                    <div className="absolute -right-5 top-[170px] -z-10 h-[260px] w-[260px] rounded-full border border-[#D5AD57]/[0.07]" />

                    <div className="mx-auto flex min-h-[70vh] w-[min(1380px,calc(100%-48px))] items-end pb-24 pt-[190px] max-sm:w-[calc(100%-28px)]">

                        <div className="max-w-[950px]">

                            <div className="flex items-center gap-4 text-sm font-bold uppercase tracking-[0.18em] text-[#D5AD57]">
                                <span className="h-px w-12 bg-current" />
                                University Committees
                            </div>

                            <h1 className="mt-7 font-['Libre_Caslon_Display',Georgia,serif] text-[clamp(50px,6.5vw,92px)] font-normal leading-[0.96] tracking-[-0.045em]">
                                Defined responsibilities.
                                <span className="block text-[#D5AD57]">
                                    Shared accountability.
                                </span>
                            </h1>

                            <p className="mt-8 max-w-[760px] text-[17px] leading-8 text-white/70">
                                Explore the committees that support academic
                                administration, student welfare, safety,
                                inclusion, campus life and grievance redressal
                                at ISBM University.
                            </p>

                            <div className="mt-10 flex flex-wrap items-center gap-x-10 gap-y-5">

                                <a
                                    href="#responsibilities"
                                    className="inline-flex min-h-[54px] items-center gap-8 bg-[#D5AD57] px-7 text-sm font-bold uppercase tracking-[0.1em] text-[#071A2F] transition hover:bg-white"
                                >
                                    Explore Responsibilities
                                    <span>↓</span>
                                </a>

                                <div className="flex items-center gap-4">

                                    <strong className="font-['Libre_Caslon_Display',Georgia,serif] text-[38px] font-normal text-[#D5AD57]">
                                        {String(committees.length).padStart(
                                            2,
                                            "0"
                                        )}
                                    </strong>

                                    <span className="text-xs font-bold uppercase leading-5 tracking-[0.12em] text-white/50">
                                        University
                                        <br />
                                        Committees
                                    </span>

                                </div>

                            </div>

                        </div>

                    </div>

                </section>

                {/* DEFINED RESPONSIBILITIES */}
                <section
                    id="responsibilities"
                    className="bg-white py-20 sm:py-24 lg:py-28"
                >

                    <div className="mx-auto w-[min(1380px,calc(100%-48px))] max-sm:w-[calc(100%-28px)]">

                        <div className="grid gap-14 lg:grid-cols-[0.72fr_1.28fr] lg:gap-20">

                            {/* LEFT INTRO */}

                            <div>

                                <Eyebrow>
                                    Defined Responsibilities
                                </Eyebrow>

                                <Title
                                    before="Committees With"
                                    highlight="Clear Institutional Roles"
                                    after=""
                                    position="middle"
                                    theme="burgundy"
                                />

                                <p className="mt-7 max-w-[500px] text-[15px] leading-8 text-[#132337]/60">
                                    The University's 16 committees support
                                    different dimensions of academic
                                    administration, student wellbeing,
                                    inclusion, campus engagement and
                                    institutional responsibility.
                                </p>

                                <div className="mt-10 border-l-[3px] border-[#D5AD57] pl-6">

                                    <p className="font-['Libre_Caslon_Display',Georgia,serif] text-[24px] leading-[1.45] text-[#071A2F]">
                                        Different committees.

                                        <span className="block text-[#8B1E3F]">
                                            One responsible university
                                            ecosystem.
                                        </span>

                                    </p>

                                </div>

                                <div className="mt-10 grid grid-cols-2 border-y border-[#071A2F]/10">

                                    <div className="border-r border-[#071A2F]/10 py-5">

                                        <strong className="font-['Libre_Caslon_Display',Georgia,serif] text-[38px] font-normal text-[#8B1E3F]">
                                            16
                                        </strong>

                                        <span className="mt-1 block text-xs font-bold uppercase tracking-[0.12em] text-[#071A2F]/55">
                                            Committees
                                        </span>

                                    </div>

                                    <div className="py-5 pl-7">

                                        <strong className="font-['Libre_Caslon_Display',Georgia,serif] text-[38px] font-normal text-[#D5AD57]">
                                            04
                                        </strong>

                                        <span className="mt-1 block text-xs font-bold uppercase tracking-[0.12em] text-[#071A2F]/55">
                                            Responsibility Areas
                                        </span>

                                    </div>

                                </div>

                            </div>


                            {/* RESPONSIBILITY GROUPS */}

                            <div className="grid gap-px bg-[#071A2F]/10 sm:grid-cols-2">

                                {responsibilityGroups.map((group) => (

                                    <article
                                        key={group.number}
                                        className={`
                                            group
                                            min-h-[390px]
                                            p-8
                                            transition
                                            lg:p-9
                                            ${group.background}
                                            ${group.dark
                                                ? "text-white"
                                                : "text-[#071A2F]"
                                            }
                                        `}
                                    >

                                        <div className="flex items-start justify-between gap-5">

                                            <span
                                                className={`
                                                    text-xs
                                                    font-bold
                                                    uppercase
                                                    tracking-[0.15em]
                                                    ${group.dark
                                                        ? "text-[#D5AD57]"
                                                        : "text-[#8B1E3F]"
                                                    }
                                                `}
                                            >
                                                {group.label}
                                            </span>

                                            <span className="font-['Libre_Caslon_Display',Georgia,serif] text-[35px] text-[#D5AD57]">
                                                {group.number}
                                            </span>

                                        </div>

                                        <h3 className="mt-10 font-['Libre_Caslon_Display',Georgia,serif] text-[29px] font-normal leading-[1.15]">
                                            {group.title}
                                        </h3>

                                        <p
                                            className={`
                                                mt-5
                                                text-sm
                                                leading-7
                                                ${group.dark
                                                    ? "text-white/60"
                                                    : "text-[#132337]/60"
                                                }
                                            `}
                                        >
                                            {group.description}
                                        </p>

                                        <div className="mt-8 space-y-3">

                                            {group.committees.map(
                                                (committeeTitle) => {
                                                    const committee =
                                                        committees.find(
                                                            (item) =>
                                                                item.title ===
                                                                committeeTitle
                                                        );

                                                    if (!committee)
                                                        return null;

                                                    return (
                                                        <div
                                                            key={
                                                                committee.title
                                                            }
                                                            className="flex items-start gap-3"
                                                        >

                                                            <span
                                                                className={`
                                                                    mt-2
                                                                    h-1.5
                                                                    w-1.5
                                                                    shrink-0
                                                                    rotate-45
                                                                    ${group.dark
                                                                        ? "bg-[#D5AD57]"
                                                                        : "bg-[#8B1E3F]"
                                                                    }
                                                                `}
                                                            />

                                                            <span
                                                                className={`
                                                                    text-sm
                                                                    font-semibold
                                                                    leading-6
                                                                    ${group.dark
                                                                        ? "text-white/85"
                                                                        : "text-[#071A2F]"
                                                                    }
                                                                `}
                                                            >
                                                                {committee.shortTitle ||
                                                                    committee.title}
                                                            </span>

                                                        </div>
                                                    );
                                                }
                                            )}

                                        </div>

                                    </article>

                                ))}

                            </div>

                        </div>


                        {/* BOTTOM MESSAGE */}

                        <div className="mt-12 flex flex-col gap-6 border-t border-[#071A2F]/15 pt-8 md:flex-row md:items-center md:justify-between">

                            <p className="max-w-[720px] text-sm leading-7 text-[#132337]/55">
                                Detailed committee composition and member
                                information is available in the complete
                                committee directory below.
                            </p>

                            <a
                                href="#committee-directory"
                                className="group inline-flex items-center gap-6 text-sm font-bold uppercase tracking-[0.12em] text-[#8B1E3F]"
                            >
                                View Committee Members

                                <span className="transition-transform group-hover:translate-y-1">
                                    ↓
                                </span>

                            </a>

                        </div>

                    </div>

                </section>

                {/* COMPLETE COMMITTEE DIRECTORY */}
                <section
                    id="committee-directory"
                    className="bg-[#EEF4F8] py-20 sm:py-24 lg:py-28"
                >

                    <div className="mx-auto w-[min(1380px,calc(100%-48px))] max-sm:w-[calc(100%-28px)]">

                        <div className="grid gap-8 border-b border-[#071A2F]/15 pb-10 lg:grid-cols-[1fr_.55fr] lg:items-end">

                            <div>

                                <Eyebrow>
                                    Complete Committee Directory
                                </Eyebrow>

                                <Title
                                    before="All Committees"
                                    highlight="And Their Members"
                                    after=""
                                    position="middle"
                                    theme="burgundy"
                                />

                            </div>

                            <p className="max-w-[470px] text-[15px] leading-8 text-[#132337]/60">
                                Expand any committee below to view its defined
                                responsibility and complete member composition.
                            </p>

                        </div>


                        <div className="mt-12 space-y-4">

                            {committees.map(
                                (committee, committeeIndex) => (

                                    <details
                                        key={committee.title}
                                        className="group overflow-hidden border border-[#071A2F]/10 bg-white transition open:shadow-[0_18px_50px_rgba(7,26,47,0.08)]"
                                    >

                                        <summary className="grid cursor-pointer list-none gap-5 px-6 py-6 sm:grid-cols-[60px_1fr_auto] sm:items-center sm:px-8">

                                            <span className="font-['Libre_Caslon_Display',Georgia,serif] text-[28px] text-[#D5AD57]">
                                                {String(
                                                    committeeIndex + 1
                                                ).padStart(2, "0")}
                                            </span>


                                            <div>

                                                <span className="text-[11px] font-bold uppercase tracking-[0.14em] text-[#8B1E3F]">
                                                    {committee.tag}
                                                </span>

                                                <h3 className="mt-2 max-w-[800px] font-['Libre_Caslon_Display',Georgia,serif] text-[24px] font-normal leading-[1.25] text-[#071A2F] sm:text-[26px]">
                                                    {committee.shortTitle ||
                                                        committee.title}
                                                </h3>

                                                {committee.shortTitle && (
                                                    <p className="mt-2 max-w-[800px] text-xs leading-5 text-[#132337]/45">
                                                        {committee.title}
                                                    </p>
                                                )}

                                            </div>


                                            <div className="flex items-center gap-5">

                                                <span className="hidden text-sm text-[#132337]/45 sm:block">
                                                    {
                                                        committee.members
                                                            .length
                                                    }{" "}
                                                    members
                                                </span>

                                                <span className="grid h-10 w-10 shrink-0 place-items-center rounded-full border border-[#071A2F]/15 text-[#8B1E3F] transition duration-300 group-open:rotate-45 group-open:border-[#8B1E3F] group-open:bg-[#8B1E3F] group-open:text-white">
                                                    +
                                                </span>

                                            </div>

                                        </summary>


                                        <div className="border-t border-[#071A2F]/10">

                                            {/* RESPONSIBILITY */}

                                            <div className="grid gap-4 bg-[#F7F2E8]/70 px-6 py-6 sm:grid-cols-[180px_1fr] sm:px-8">

                                                <span className="text-xs font-bold uppercase tracking-[0.13em] text-[#8B1E3F]">
                                                    Responsibility
                                                </span>

                                                <p className="max-w-[900px] text-sm leading-7 text-[#132337]/60">
                                                    {
                                                        committee.responsibility
                                                    }
                                                </p>

                                            </div>


                                            {/* TABLE HEADER */}

                                            <div className="hidden grid-cols-[55px_1fr_300px] border-t border-[#071A2F]/10 bg-[#071A2F] px-8 py-4 text-xs font-bold uppercase tracking-[0.12em] text-white/60 sm:grid">

                                                <span>No.</span>
                                                <span>Member Name</span>
                                                <span>
                                                    Designation / Role
                                                </span>

                                            </div>


                                            {/* MEMBERS */}

                                            {committee.members.map(
                                                (member, index) => (

                                                    <div
                                                        key={`${committee.title}-${member.name}-${index}`}
                                                        className="grid gap-3 border-t border-[#071A2F]/10 px-6 py-5 first:border-t-0 sm:grid-cols-[55px_1fr_300px] sm:items-center sm:px-8"
                                                    >

                                                        <span className="text-xs font-bold text-[#D5AD57]">
                                                            {String(
                                                                index + 1
                                                            ).padStart(
                                                                2,
                                                                "0"
                                                            )}
                                                        </span>

                                                        <strong className="font-['Libre_Caslon_Display',Georgia,serif] text-[19px] font-normal leading-[1.3] text-[#071A2F]">
                                                            {
                                                                member.name
                                                            }
                                                        </strong>

                                                        <span className="text-sm leading-6 text-[#8B1E3F]">
                                                            {
                                                                member.designation
                                                            }
                                                        </span>

                                                    </div>

                                                )
                                            )}

                                        </div>

                                    </details>

                                )
                            )}

                        </div>


                        {/* DIRECTORY FOOTER */}

                        <div className="mt-10 flex flex-col gap-6 border-t border-[#071A2F]/15 pt-7 md:flex-row md:items-center md:justify-between">

                            <p className="max-w-[750px] text-sm leading-7 text-[#132337]/55">
                                The directory above contains{" "}
                                <strong className="text-[#071A2F]">
                                    {committees.length} University committees
                                </strong>{" "}
                                and their respective members as provided in the
                                current committee information.
                            </p>

                            <a
                                href="#responsibilities"
                                className="inline-flex items-center gap-5 text-sm font-bold uppercase tracking-[0.12em] text-[#8B1E3F]"
                            >
                                Back to Responsibilities
                                <span>↑</span>
                            </a>

                        </div>

                    </div>

                </section>

            </main>

            <Footer />
        </>
    );
}